<template>
    <v-app id="inspire">
        <!-- Install dialog shown on IOS device -->
        <div class="text-center">
            <v-bottom-sheet v-model="prompt" persistent>
                <v-sheet class="text-center" height="200px">
                    <div class="py-3">
                        <v-btn icon>
                            <v-icon large>mdi-plus-box</v-icon>
                        </v-btn>
                        Install ClimateRX: Tap
                        <v-btn icon>
                            <v-icon>mdi-export-variant</v-icon>
                        </v-btn>
                        and then Add to Homescreen
                    </div>
                    <v-btn
                        class="mt-6"
                        text
                        color="error"
                        @click="prompt = !prompt"
                    >
                        close
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <v-banner class="banner text-left" v-if="deferredPrompt">
            <v-icon slot="icon" color="warning" size="24"> mdi-star </v-icon>
            Add ClimateRX App to your Home Screen
            <template v-slot:actions>
                <v-btn text color="white" @click="dismiss">Dismiss</v-btn>
                <v-btn text color="white" @click="install">Install</v-btn>
            </template>
        </v-banner>

        <v-snackbar v-model="flag" top color="error top-element">
            {{ message
            }}
            <v-btn color="white" text @click="flag = false">
                Close
            </v-btn
            >
        </v-snackbar >

        <!-- main template -->
        <div class="login-container">
            <div class="login-background">
                <div class="background-pattern"></div>
                <div class="background-gradient"></div>
            </div>
            
            <v-container fluid class="login-content">
                <v-row no-gutters class="min-height-100vh">
                    <!-- Column 1 - Logo Section -->
                    <v-col cols="12" sm="12" md="6" class="logo-column d-none d-md-flex">
                        <div class="logo-content">
                            <v-img 
                                src="../assets/crx-main-logo.png" 
                                class="main-logo"
                                contain
                            ></v-img>
                            <p class="app-version">{{appVersion}}</p>
                        </div>
                    </v-col>
                    
                    <!-- Column 2 - Login Form -->
                    <v-col cols="12" sm="12" md="6" class="login-column">
                        <div class="login-container-inner">
                            <div class="login-form-wrapper">
                                <!-- Mobile Logo at Top -->
                                <div class="mobile-logo-top d-md-none">
                                    <v-img 
                                        src="../assets/crx-main-logo-1.png" 
                                        class="mobile-top-logo"
                                        contain
                                    ></v-img>
                                </div>
                                
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                    class="login-form"
                                >
                                    <div class="input-group">
                                        <v-text-field
                                            name="email"
                                            label="Email Address"
                                            required
                                            v-model="email"
                                            :rules="emailRules"
                                            prepend-inner-icon="mdi-email-outline"
                                            type="email"
                                            variant="outlined"
                                            class="form-input"
                                            color="primary"
                                            v-on:keyup="onEnterKey"
                                            autocomplete="email"
                                            hide-details="auto"
                                        ></v-text-field>
                                    </div>
                                    
                                    <div class="input-group">
                                        <v-text-field
                                            id="password"
                                            label="Password"
                                            required
                                            name="password"
                                            v-model="password"
                                            :rules="passwordRules"
                                            prepend-inner-icon="mdi-lock-outline"
                                            :type="showPassword ? 'text' : 'password'"
                                            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                            @click:append="showPassword = !showPassword"
                                            variant="outlined"
                                            class="form-input"
                                            color="primary"
                                            v-on:keyup="onEnterKey"
                                            autocomplete="current-password"
                                            hide-details="auto"
                                        ></v-text-field>
                                    </div>
                                    
                                    <div class="form-options d-flex justify-end align-center">
                                        <router-link
                                            to="/forgot-password"
                                            class="forgot-link"
                                        >
                                            Forgot Password?
                                        </router-link>
                                    </div>
                                    
                                    <v-btn
                                        class="signin-btn text-uppercase"
                                        color="primary"
                                        size="x-large"
                                        variant="flat"
                                        block
                                        :loading="loading"
                                        @click="loginUser"
                                    >
                                       Login
                                    </v-btn>
                                </v-form>
                                
                                <div class="terms-privacy-links text-center mt-4">
                                    <p class="terms-text">
                                        This system is subject to our 
                                        <router-link to="/terms-of-service" class="terms-link">Terms of Use</router-link> and 
                                        <router-link to="/privacy-policy" class="privacy-link">Privacy Policy</router-link>.
                                    </p>
                                </div>
                                
                                <div class="mobile-version-bottom d-md-none">
                                    <p class="mobile-version">{{appVersion}}</p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>

        <!-- <v-snackbar v-model="flag" top color="error">
          Can't login with that credentials!<v-btn
            color="white"
            text
            @click="
              flag = false;
              loading = false;
            "
          >
            Close</v-btn
          ></v-snackbar> -->
    </v-app>
</template>

<script>
import { mapActions } from "vuex";
import Cookies from "js-cookie";

export default {
    props: {
        source: String,
    },
    data() {
        return {
            appVersion: "v.1.8.13a.2025",
            deferredPrompt: null,
            valid: true,
            loading: false,
            flag: false,
            email: "",
            prompt: null,
            message: "",
            showPassword: false,
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            password: "",
            passwordRules: [(v) => !!v || "Password is required"],
        };
    },
    head: {
        meta: [{ name: "ClimateRX", content: "ClimateRX" }],
        link: [
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon.png"),
                type: "image/png",
            },
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon-144x144.png"),
                sizes: "144x144",
                type: "image/png",
            },
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon-152x152.png"),
                sizes: "152x152",
                type: "image/png",
            },
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon-180x180.png"),
                sizes: "180x180",
                type: "image/png",
            },
        ],
        script: [
            // { type: 'text/javascript', src: require('@/assets/test.js'), async: true, body: true},
        ],
    },
    computed: {
        permissions() {
            return this.$store.state.roles.permissions;
        },
    },
    created() {
        this.checkDevice();
        window.addEventListener("beforeinstallprompt", (e) => {
            e.preventDefault();
            if (Cookies.get("add-to-home-screen") === undefined) {
                this.deferredPrompt = e;
            }
        });
        window.addEventListener("appinstalled", () => {
            this.deferredPrompt = null;
        });
    },
    methods: {
        ...mapActions({
            login: "login",
            getRoles: "roles/getUserPermissions",
        }),
        async dismiss() {
            Cookies.set("add-to-home-screen", null, { expires: 15 });
            this.deferredPrompt = null;
        },
        async install() {
            this.deferredPrompt.prompt();
        },
        validate() {
            return this.$refs.form.validate();
        },
        loginUser() {
            this.loading = true;
            if (this.validate()) {
                let user = {
                    Email: this.email,
                    Password: this.password,
                };
                this.login(user)
                    .then((res) => {
                        if (!res.data.success) {
                            this.flag = true;
                            this.loading = false;
                            this.message = res.data.msg;
                            console.log("flagged");
                            return;
                        }

                        this.getRoles();

                        const nextPath = this.$route.query.next;

                        if (nextPath) {
                            this.$router.push(decodeURI(nextPath));
                        } else {
                            if (
                                res.data.user.Role === "Direct Care Staff" ||
                                res.data.user.Role === "Shift Lead" ||
                                res.data.user.Role === "Assistant Manager" ||
                                res.data.user.Role === "House Manager" ||
                                res.data.user.Role === "Program Manager" ||
                                res.data.user.Role === "Human Resources" ||
                                res.data.user.Role ===
                                    "Client Services Manager" ||
                                res.data.user.Role === "Program Coordinator" ||
                                res.data.user.Role === "Medical Manager" ||
                                res.data.user.Role === "Executive Director" ||
                                res.data.user.Role === "Finance Manager" ||
                                res.data.user.Role === "Compliance Manager" ||
                                res.data.user.Role === "Administration" ||
                                res.data.user.Role === "SuperAdministrator"
                            ) {
                                // if (
                                //     res.data.user.VerificationStatus !==
                                //         "Verified" &&
                                //     res.data.user.Role !== "Administration" &&
                                //     res.data.user.Role !== "SuperAdministrator"
                                // ) 
                                // {
                                //     return this.$router.push({
                                //         name: "NewHirePortal",
                                //         params: { empID: res.data.user._id },
                                //     });
                                // }

                                if (
                                    localStorage.getItem("autoLogout") ===
                                    "auto"
                                ) {
                                    let page = localStorage.getItem("lastPage");
                                    localStorage.removeItem("autoLogout");
                                    localStorage.removeItem("lastPage");
                                    return this.$router.push(page);
                                } else {
                                    return this.$router.push(
                                        "/staffInfo/" + res.data.user._id,
                                        () => {}
                                    );
                                }
                            } /*else if (res.data.user.Role == "Client - Basic" ||
                            res.data.user.Role == "Client - Billing" ||
                            res.data.user.Role == "Client - Intake" ||
                            res.data.user.Role == "Client - Med/Mar" ||
                            res.data.user.Role == "Client - Service/Plan/ADLs" ||
                            res.data.user.Role == "Client - Support Strategies"
                        ) {
                            if (res.data.user.VerificationStatus != "Verified") {
                                this.$router.push({name: 'NewHirePortal', params: {empID: res.data.user._id}})
                            } else {
                                this.$router.push("/clientinfo");
                            }
                        }*/ else if (
                                res.data.user.Role === "Parent/Guardian" ||
                                res.data.user.Role === "Support Coordinator" ||
                                res.data.user.Role === "Client"
                            ) {
                                if (
                                    localStorage.getItem("autoLogout") ===
                                    "auto"
                                ) {
                                    let page = localStorage.getItem("lastPage");
                                    localStorage.removeItem("autoLogout");
                                    localStorage.removeItem("lastPage");
                                    return this.$router.push(page);
                                } else {
                                    let clientID = localStorage.getItem("clientId");
                                    if (clientID == '') clientID = localStorage.getItem("userID");

                                    this.$router.push("/clientInfo/" + clientID);
                                }
                            } else if (res.data.user.Role === "Pharmacy") {
                                if (
                                    localStorage.getItem("autoLogout") ===
                                    "auto"
                                ) {
                                    let page = localStorage.getItem("lastPage");
                                    localStorage.removeItem("autoLogout");
                                    localStorage.removeItem("lastPage");
                                    return this.$router.push(page);
                                } else {
                                    this.$router.push("/client");
                                }
                            } else {
                                this.$router.push("/");
                            }
                            //console.log("logged in");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                this.loading = false;
            }
        },
        onEnterKey: function (e) {
            if (e.keyCode === 13) {
                this.loginUser();
            }
        },
        checkDevice() {
            const isIos = () => {
                const userAgent = window.navigator.userAgent.toLowerCase();
                return /iphone|ipad|ipod/.test(userAgent);
            };
            const isInStandaloneMode = () =>
                "standalone" in window.navigator && window.navigator.standalone;
            if (isIos() && !isInStandaloneMode()) {
                this.prompt = true;
            }
        },
    },
};
</script>

<style scoped>
.login-container {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    padding: 0px;
}

.login-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}

.background-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f8fafc;
}

.background-pattern {
    display: none;
}

.login-content {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    padding: 0 !important;
}

.min-height-100vh {
    min-height: 100vh;
}

.logo-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    z-index: 1;
    position: relative;
}

.app-version {
    font-size: 1.5rem;
    font-weight: 400;
    color: #2b3990;
    margin: 0;
    font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
    letter-spacing: 0.5px;
}

.logo-column {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    position: relative;
}

.logo-column::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(43, 57, 144, 0.02) 0%, transparent 100%);
    pointer-events: none;
}

.main-logo {
    opacity: 0.95;
    filter: drop-shadow(0 4px 16px rgba(43, 57, 144, 0.15));
    width: 90%;
    max-width: 600px;
    height: auto;
    min-width: 200px;
}

.main-logo :deep(.v-img__img) {
    object-fit: contain;
    width: 100%;
    height: auto;
}

.login-container-inner {
    width: 100%;
    max-width: 450px;
}

.login-form-wrapper {
    padding: 0;
    margin: 20px;
}

.login-column {
    background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 2rem;
}

.input-group {
    position: relative;
}

.form-options {
    margin: 0.5rem 0;
}

/* Mobile logo and version */
.mobile-logo-top {
    text-align: center;
    margin-bottom: 1.5rem;
}

.mobile-top-logo {
    width: 234px;
    height: auto;
    opacity: 0.9;
    margin: 0 auto;
}

.mobile-version-bottom {
    text-align: center;
    margin-top: 1.5rem;
    padding-top: 1.25rem;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.mobile-version {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
    font-weight: 400;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin: 1.5rem 0;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.form-input {
    margin-bottom: 1.5rem;
}

.form-input :deep(.v-field) {
    border-radius: 8px;
    background: #fafbfc;
    border: 1px solid #d0d7de;
}

.form-input :deep(.v-field--focused) {
    background: white;
    border-color: #2b3990;
    box-shadow: 0 0 0 3px rgba(43, 57, 144, 0.1);
}

.form-input :deep(.v-field--error) {
    border-color: #dc2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.form-input :deep(.v-field__input) {
    padding: 0.75rem;
    font-size: 1rem;
    color: #374151;
    font-weight: 500;
}

.form-input :deep(.v-label) {
    font-weight: 500;
    color: #6b7280;
}

.form-input :deep(.v-field__prepend-inner) {
    color: #6b7280;
    margin-right: 0.75rem;
}

.form-input :deep(.v-field__append-inner) {
    color: #6b7280;
    margin-left: 0.75rem;
    display: flex !important;
    align-items: center !important;
    opacity: 1 !important;
    visibility: visible !important;
}

.form-input :deep(.v-field__append-inner .v-btn) {
    color: #6b7280 !important;
    min-width: auto !important;
    width: 32px !important;
    height: 32px !important;
}

.form-input :deep(.v-field__append-inner .v-btn:hover) {
    color: #2b3990 !important;
}

.form-input :deep(.v-field__append-inner .v-icon) {
    font-size: 1.2rem !important;
    color: inherit !important;
}

.forgot-link {
    color: #2b3990;
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: 500;
}


.terms-text {
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 0.8rem !important;
    line-height: 1.5;
    margin: 0;
    font-weight: 400;
}

.terms-link, .privacy-link {
    color: #ffffff !important;
    text-decoration: underline;
    font-weight: 600;
    transition: all 0.2s ease;
}

.terms-link:hover, .privacy-link:hover {
    color: #e3f2fd !important;
    text-decoration: none;
    text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
}

.signin-btn {
    background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%) !important;
    color: white !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    font-size: 1rem !important;
    text-transform: uppercase !important;
    letter-spacing: 0.025em !important;
    box-shadow: 
        0 8px 20px rgba(43, 57, 144, 0.3),
        0 4px 10px rgba(43, 57, 144, 0.2) !important;
    margin-top: 1rem;
}

.banner {
    z-index: 9998;
}

.top-element {
    z-index: 9999;
}

.v-banner__wrapper {
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
}

/* Responsive design */
@media (max-width: 1400px) {
    .main-logo {
        width: 85%;
        max-width: 500px;
    }
}

@media (max-width: 1200px) {
    .main-logo {
        width: 80%;
        max-width: 450px;
    }
    
    .app-version {
        font-size: 1.4rem;
    }
}

/* Tablet and below - Stack vertically */
@media (max-width: 960px) {
    .logo-column {
        min-height: 35vh;
        padding: 2rem 1rem 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .login-column {
        min-height: 65vh;
        padding: 1rem;
        background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .main-logo {
        width: 75%;
        max-width: 400px;
        min-width: 250px;
    }
    
    .app-version {
        font-size: 1.3rem;
    }
    
    .logo-content {
        gap: 1.5rem;
    }
}

@media (max-width: 768px) {
    .logo-column {
        min-height: 30vh;
        padding: 1.5rem 1rem 0.5rem;
    }
    
    .login-column {
        min-height: 70vh;
        padding: 0.5rem 1rem 1rem;
    }
    
    .main-logo {
        width: 70%;
        max-width: 320px;
        min-width: 200px;
    }
    
    .app-version {
        font-size: 1.2rem;
    }
}

/* Mobile phones */
@media (max-width: 960px) {
    .login-column {
        min-height: 100vh;
        padding: 2rem 1.5rem 1.5rem;
        background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .login-form {
        padding: 1.75rem;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
        margin: 1rem 0;
    }
    
    .form-input :deep(.v-field) {
        border-radius: 12px;
        background: #f9fafb;
        border: 2px solid #e5e7eb;
        min-height: 48px;
    }
    
    .form-input :deep(.v-field--focused) {
        background: white;
        border-color: #2b3990;
        box-shadow: 0 0 0 4px rgba(43, 57, 144, 0.1);
    }
    
    .form-input :deep(.v-field__input) {
        padding: 0.875rem;
        font-size: 1rem;
        color: #1f2937;
        font-weight: 500;
    }
    
    .form-input :deep(.v-label) {
        font-size: 1rem;
        font-weight: 600;
        color: #6b7280;
    }
    
    .form-input :deep(.v-field__prepend-inner) {
        color: #6b7280;
        margin-right: 1rem;
        font-size: 1.25rem;
    }
    
    .form-input :deep(.v-field__append-inner) {
        color: #6b7280;
        margin-left: 1rem;
        font-size: 1.25rem;
    }
    
    .forgot-link {
        font-size: 1rem;
        font-weight: 600;
        color: #2b3990;
        padding: 0.5rem 0;
    }
    
    .signin-btn {
        min-height: 48px !important;
        font-size: 1.05rem !important;
        font-weight: 700 !important;
        border-radius: 12px !important;
        margin: 1.5rem 0 1rem 0;
        box-shadow: 0 8px 24px rgba(43, 57, 144, 0.25) !important;
    }
    
    .terms-privacy-links {
        margin-top: 1.25rem;
        padding: 10px;
    }
    
    .terms-text {
        font-size: 0.85rem !important;
    }
}

/* Small mobile phones */
@media (max-width: 480px) {
    .login-column {
        padding: 1.5rem 1.25rem 1.25rem;
    }
    
    .login-form {
        padding: 1.5rem;
        border-radius: 12px;
        margin: 0.75rem 0;
    }
    
    .form-input :deep(.v-field) {
        min-height: 44px;
        border-radius: 10px;
    }
    
    .form-input :deep(.v-field__input) {
        padding: 0.75rem;
        font-size: 1rem;
    }
    
    .form-input :deep(.v-label) {
        font-size: 0.9rem;
    }
    
    .form-input :deep(.v-field__prepend-inner) {
        font-size: 1.125rem;
        margin-right: 0.875rem;
    }
    
    .form-input :deep(.v-field__append-inner) {
        font-size: 1.125rem;
        margin-left: 0.875rem;
    }
    
    .forgot-link {
        font-size: 0.9rem;
    }
    
    .signin-btn {
        min-height: 44px !important;
        font-size: 1rem !important;
        border-radius: 10px !important;
        margin: 1rem 0;
    }
    
    .terms-privacy-links {
        margin-top: 1rem;
        padding: 8px;
    }
    
    .terms-text {
        font-size: 0.8rem !important;
    }
}

/* Very small screens */
@media (max-width: 360px) {
    .login-column {
        padding: 1.25rem 1rem 1rem;
    }
    
    .login-form {
        padding: 1.25rem;
        border-radius: 10px;
        margin: 0.5rem 0;
    }
    
    .form-input :deep(.v-field) {
        min-height: 40px;
        border-radius: 8px;
    }
    
    .form-input :deep(.v-field__input) {
        padding: 0.625rem;
        font-size: 0.95rem;
    }
    
    .form-input :deep(.v-label) {
        font-size: 0.85rem;
    }
    
    .form-input :deep(.v-field__prepend-inner) {
        font-size: 1rem;
        margin-right: 0.75rem;
    }
    
    .form-input :deep(.v-field__append-inner) {
        font-size: 1rem;
        margin-left: 0.75rem;
    }
    
    .forgot-link {
        font-size: 0.85rem;
    }
    
    .signin-btn {
        min-height: 40px !important;
        font-size: 0.95rem !important;
        border-radius: 8px !important;
        margin: 0.75rem 0;
    }
    
    .terms-privacy-links {
        margin-top: 0.75rem;
        padding: 6px;
    }
    
    .terms-text {
        font-size: 0.75rem !important;
    }
}
</style>
